// List of all timezone geojson files
const TIMEZONE_FILES = [
  'Africa__Abidjan', 'Africa__Accra', 'Africa__Addis_Ababa', 'Africa__Algiers', 'Africa__Asmara',
  'Africa__Bamako', 'Africa__Bangui', 'Africa__Banjul', 'Africa__Bissau', 'Africa__Blantyre',
  'Africa__Brazzaville', 'Africa__Bujumbura', 'Africa__Cairo', 'Africa__Casablanca', 'Africa__Ceuta',
  'Africa__Conakry', 'Africa__Dakar', 'Africa__Dar_es_Salaam', 'Africa__Djibouti', 'Africa__Douala',
  'Africa__El_Aaiun', 'Africa__Freetown', 'Africa__Gaborone', 'Africa__Harare', 'Africa__Johannesburg',
  'Africa__Juba', 'Africa__Kampala', 'Africa__Khartoum', 'Africa__Kigali', 'Africa__Kinshasa',
  'Africa__Lagos', 'Africa__Libreville', 'Africa__Lome', 'Africa__Luanda', 'Africa__Lubumbashi',
  'Africa__Lusaka', 'Africa__Malabo', 'Africa__Maputo', 'Africa__Maseru', 'Africa__Mbabane',
  'Africa__Mogadishu', 'Africa__Monrovia', 'Africa__Nairobi', 'Africa__Ndjamena', 'Africa__Niamey',
  'Africa__Nouakchott', 'Africa__Ouagadougou', 'Africa__Porto-Novo', 'Africa__Sao_Tome', 'Africa__Tripoli',
  'Africa__Tunis', 'Africa__Windhoek',
  'America__Adak', 'America__Anchorage', 'America__Anguilla', 'America__Antigua', 'America__Araguaina',
  'America__Argentina__Buenos_Aires', 'America__Argentina__Catamarca', 'America__Argentina__Cordoba',
  'America__Argentina__Jujuy', 'America__Argentina__La_Rioja', 'America__Argentina__Mendoza',
  'America__Argentina__Rio_Gallegos', 'America__Argentina__Salta', 'America__Argentina__San_Juan',
  'America__Argentina__San_Luis', 'America__Argentina__Tucuman', 'America__Argentina__Ushuaia',
  'America__Aruba', 'America__Asuncion', 'America__Atikokan', 'America__Bahia', 'America__Bahia_Banderas',
  'America__Barbados', 'America__Belem', 'America__Belize', 'America__Blanc-Sablon', 'America__Boa_Vista',
  'America__Bogota', 'America__Boise', 'America__Cambridge_Bay', 'America__Campo_Grande', 'America__Cancun',
  'America__Caracas', 'America__Cayenne', 'America__Cayman', 'America__Chicago', 'America__Chihuahua',
  'America__Ciudad_Juarez', 'America__Costa_Rica', 'America__Coyhaique', 'America__Creston', 'America__Cuiaba',
  'America__Curacao', 'America__Danmarkshavn', 'America__Dawson', 'America__Dawson_Creek', 'America__Denver',
  'America__Detroit', 'America__Dominica', 'America__Edmonton', 'America__Eirunepe', 'America__El_Salvador',
  'America__Fortaleza', 'America__Fort_Nelson', 'America__Glace_Bay', 'America__Goose_Bay', 'America__Grand_Turk',
  'America__Grenada', 'America__Guadeloupe', 'America__Guatemala', 'America__Guayaquil', 'America__Guyana',
  'America__Halifax', 'America__Havana', 'America__Hermosillo', 'America__Indiana__Indianapolis',
  'America__Indiana__Knox', 'America__Indiana__Marengo', 'America__Indiana__Petersburg', 'America__Indiana__Tell_City',
  'America__Indiana__Vevay', 'America__Indiana__Vincennes', 'America__Indiana__Winamac', 'America__Inuvik',
  'America__Iqaluit', 'America__Jamaica', 'America__Juneau', 'America__Kentucky__Louisville',
  'America__Kentucky__Monticello', 'America__Kralendijk', 'America__La_Paz', 'America__Lima',
  'America__Los_Angeles', 'America__Lower_Princes', 'America__Maceio', 'America__Managua', 'America__Manaus',
  'America__Marigot', 'America__Martinique', 'America__Matamoros', 'America__Mazatlan', 'America__Menominee',
  'America__Merida', 'America__Metlakatla', 'America__Mexico_City', 'America__Miquelon', 'America__Moncton',
  'America__Monterrey', 'America__Montevideo', 'America__Montserrat', 'America__Nassau', 'America__New_York',
  'America__Nome', 'America__Noronha', 'America__North_Dakota__Beulah', 'America__North_Dakota__Center',
  'America__North_Dakota__New_Salem', 'America__Nuuk', 'America__Ojinaga', 'America__Panama',
  'America__Paramaribo', 'America__Phoenix', 'America__Port-au-Prince', 'America__Porto_Velho',
  'America__Port_of_Spain', 'America__Puerto_Rico', 'America__Punta_Arenas', 'America__Rankin_Inlet',
  'America__Recife', 'America__Regina', 'America__Resolute', 'America__Rio_Branco', 'America__Santarem',
  'America__Santiago', 'America__Santo_Domingo', 'America__Sao_Paulo', 'America__Scoresbysund', 'America__Sitka',
  'America__St_Barthelemy', 'America__St_Johns', 'America__St_Kitts', 'America__St_Lucia', 'America__St_Thomas',
  'America__St_Vincent', 'America__Swift_Current', 'America__Tegucigalpa', 'America__Thule', 'America__Tijuana',
  'America__Toronto', 'America__Tortola', 'America__Vancouver', 'America__Whitehorse', 'America__Winnipeg',
  'America__Yakutat',
  'Antarctica__Casey', 'Antarctica__Davis', 'Antarctica__DumontDUrville', 'Antarctica__Macquarie',
  'Antarctica__Mawson', 'Antarctica__McMurdo', 'Antarctica__Palmer', 'Antarctica__Rothera', 'Antarctica__Syowa',
  'Antarctica__Troll', 'Antarctica__Vostok',
  'Arctic__Longyearbyen',
  'Asia__Aden', 'Asia__Almaty', 'Asia__Amman', 'Asia__Anadyr', 'Asia__Aqtau', 'Asia__Aqtobe',
  'Asia__Ashgabat', 'Asia__Atyrau', 'Asia__Baghdad', 'Asia__Bahrain', 'Asia__Baku', 'Asia__Bangkok',
  'Asia__Barnaul', 'Asia__Beirut', 'Asia__Bishkek', 'Asia__Brunei', 'Asia__Chita', 'Asia__Colombo',
  'Asia__Damascus', 'Asia__Dhaka', 'Asia__Dili', 'Asia__Dubai', 'Asia__Dushanbe', 'Asia__Famagusta',
  'Asia__Gaza', 'Asia__Hebron', 'Asia__Hong_Kong', 'Asia__Hovd', 'Asia__Ho_Chi_Minh', 'Asia__Irkutsk',
  'Asia__Jakarta', 'Asia__Jayapura', 'Asia__Jerusalem', 'Asia__Kabul', 'Asia__Kamchatka', 'Asia__Karachi',
  'Asia__Kathmandu', 'Asia__Khandyga', 'Asia__Kolkata', 'Asia__Krasnoyarsk', 'Asia__Kuala_Lumpur',
  'Asia__Kuching', 'Asia__Kuwait', 'Asia__Macau', 'Asia__Magadan', 'Asia__Makassar', 'Asia__Manila',
  'Asia__Muscat', 'Asia__Nicosia', 'Asia__Novokuznetsk', 'Asia__Novosibirsk', 'Asia__Omsk', 'Asia__Oral',
  'Asia__Phnom_Penh', 'Asia__Pontianak', 'Asia__Pyongyang', 'Asia__Qatar', 'Asia__Qostanay', 'Asia__Qyzylorda',
  'Asia__Riyadh', 'Asia__Sakhalin', 'Asia__Samarkand', 'Asia__Seoul', 'Asia__Shanghai', 'Asia__Singapore',
  'Asia__Srednekolymsk', 'Asia__Taipei', 'Asia__Tashkent', 'Asia__Tbilisi', 'Asia__Tehran', 'Asia__Thimphu',
  'Asia__Tokyo', 'Asia__Tomsk', 'Asia__Ulaanbaatar', 'Asia__Urumqi', 'Asia__Ust-Nera', 'Asia__Vientiane',
  'Asia__Vladivostok', 'Asia__Yakutsk', 'Asia__Yangon', 'Asia__Yekaterinburg', 'Asia__Yerevan',
  'Atlantic__Azores', 'Atlantic__Bermuda', 'Atlantic__Canary', 'Atlantic__Cape_Verde', 'Atlantic__Faroe',
  'Atlantic__Madeira', 'Atlantic__Reykjavik', 'Atlantic__South_Georgia', 'Atlantic__Stanley', 'Atlantic__St_Helena',
  'Australia__Adelaide', 'Australia__Brisbane', 'Australia__Broken_Hill', 'Australia__Darwin', 'Australia__Eucla',
  'Australia__Hobart', 'Australia__Lindeman', 'Australia__Lord_Howe', 'Australia__Melbourne', 'Australia__Perth',
  'Australia__Sydney',
  'Etc__UTC',
  'Europe__Amsterdam', 'Europe__Andorra', 'Europe__Astrakhan', 'Europe__Athens', 'Europe__Belgrade',
  'Europe__Berlin', 'Europe__Bratislava', 'Europe__Brussels', 'Europe__Bucharest', 'Europe__Budapest',
  'Europe__Busingen', 'Europe__Chisinau', 'Europe__Copenhagen', 'Europe__Dublin', 'Europe__Gibraltar',
  'Europe__Guernsey', 'Europe__Helsinki', 'Europe__Isle_of_Man', 'Europe__Istanbul', 'Europe__Jersey',
  'Europe__Kaliningrad', 'Europe__Kirov', 'Europe__Kyiv', 'Europe__Lisbon', 'Europe__Ljubljana',
  'Europe__London', 'Europe__Luxembourg', 'Europe__Madrid', 'Europe__Malta', 'Europe__Mariehamn',
  'Europe__Minsk', 'Europe__Monaco', 'Europe__Moscow', 'Europe__Oslo', 'Europe__Paris', 'Europe__Podgorica',
  'Europe__Prague', 'Europe__Riga', 'Europe__Rome', 'Europe__Samara', 'Europe__San_Marino', 'Europe__Sarajevo',
  'Europe__Saratov', 'Europe__Simferopol', 'Europe__Skopje', 'Europe__Sofia', 'Europe__Stockholm',
  'Europe__Tallinn', 'Europe__Tirane', 'Europe__Ulyanovsk', 'Europe__Vaduz', 'Europe__Vatican',
  'Europe__Vienna', 'Europe__Vilnius', 'Europe__Volgograd', 'Europe__Warsaw', 'Europe__Zagreb', 'Europe__Zurich',
  'Indian__Antananarivo', 'Indian__Chagos', 'Indian__Christmas', 'Indian__Cocos', 'Indian__Comoro',
  'Indian__Kerguelen', 'Indian__Mahe', 'Indian__Maldives', 'Indian__Mauritius', 'Indian__Mayotte',
  'Indian__Reunion',
  'Pacific__Apia', 'Pacific__Auckland', 'Pacific__Bougainville', 'Pacific__Chatham', 'Pacific__Chuuk',
  'Pacific__Easter', 'Pacific__Efate', 'Pacific__Fakaofo', 'Pacific__Fiji', 'Pacific__Funafuti',
  'Pacific__Galapagos', 'Pacific__Gambier', 'Pacific__Guadalcanal', 'Pacific__Guam', 'Pacific__Honolulu',
  'Pacific__Kanton', 'Pacific__Kiritimati', 'Pacific__Kosrae', 'Pacific__Kwajalein', 'Pacific__Majuro',
  'Pacific__Marquesas', 'Pacific__Midway', 'Pacific__Nauru', 'Pacific__Niue', 'Pacific__Norfolk',
  'Pacific__Noumea', 'Pacific__Pago_Pago', 'Pacific__Palau', 'Pacific__Pitcairn', 'Pacific__Pohnpei',
  'Pacific__Port_Moresby', 'Pacific__Rarotonga', 'Pacific__Saipan', 'Pacific__Tahiti', 'Pacific__Tarawa',
  'Pacific__Tongatapu', 'Pacific__Wake', 'Pacific__Wallis'
];

/**
 * Load all timezone geojson files and combine them into a FeatureCollection
 * @returns {Promise<Object>} FeatureCollection with all timezone features
 */
export async function loadTimezonesGeoJSON() {
  try {
    const features = [];
    
    // Load all geojson files in parallel
    const promises = TIMEZONE_FILES.map(async (filename) => {
      try {
        const response = await fetch(`/geojson/timezone-geojson/${filename}.geojson`);
        if (!response.ok) {
          console.warn(`Failed to load ${filename}.geojson`);
          return null;
        }
        const feature = await response.json();
        return feature;
      } catch (error) {
        console.warn(`Error loading ${filename}.geojson:`, error);
        return null;
      }
    });
    
    const results = await Promise.all(promises);
    
    // Filter out null results and add to features array
    results.forEach(feature => {
      if (feature) {
        features.push(feature);
      }
    });
    
    console.log(`Loaded ${features.length} timezone features`);
    
    // Return as FeatureCollection
    return {
      type: "FeatureCollection",
      features: features
    };
  } catch (error) {
    console.error('Error loading timezones:', error);
    throw error;
  }
}
